import { useEffect, useState } from "react";
import { CancellableAPIRequest } from "restAPI";

export default function useAPIResponse<T>(
  callback: () => CancellableAPIRequest<T>,
  dependency: any[],
): [T | undefined, boolean] {
  const [response, setResponse] = useState<T>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const { promise, cancel } = callback();
    promise.then(setResponse).finally(() => setLoading(false));
    return cancel;
  }, dependency);

  return [response, loading];
}
